var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DaiBarrasAgrupadasV2',{attrs:{"titulo":_vm.encabezado,"instruccional":'Última actualización: '+_vm.fechaActualizacion,"datos":_vm.datosGrafica,"variables":_vm.variablesGrafica,"nombre_variables":{nombre:'nombre'},"orientacion":_vm.screenIsMobile &&
    this.$store.getters.estadoSeleccionado === '00'
    ? 'vertical' : 'horizontal',"titulo_leyenda":"Estado de los pacientes"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }